import { IHomePageSubCategoryWithCoursesHit } from '@/types/search'
import { AvailableLanguages } from '../../shared/providers/LanguageSelectionProvider'

export type GroupedSubCategoryCourses<L extends AvailableLanguages> = Record<
  string,
  {
    courses: IHomePageSubCategoryWithCoursesHit<L>['course'][]
    name: string
    slug: string
  }
>

export function groupHitsBySubCategory<L extends AvailableLanguages>(
  hits: IHomePageSubCategoryWithCoursesHit<L>[]
): GroupedSubCategoryCourses<L> {
  return hits.reduce((acc, { course, subcategory }) => {
    if (!course || !subcategory) {
      return acc
    }

    if (acc[subcategory.id]) {
      acc[subcategory.id].courses.push(course)
    } else {
      acc[subcategory.id] = {
        courses: [course],
        name: subcategory.name,
        slug: subcategory.slug,
      }
    }
    return acc
  }, {} as GroupedSubCategoryCourses<L>)
}
